import api from '@/api';
import { BankSlipReportRequest } from './BankSlip.types';

const baseUrl = 'reports/v1/generate/bank-slip';

export default {
  async getReportBankSlip(params: BankSlipReportRequest) {
    const result = (await api.getReport(`${baseUrl}`, params)) as unknown;

    return result as BlobPart;
  },
};
